import React, {useContext, useState} from 'react';
import {Navigate, useLocation, useParams} from "react-router-dom";
import {SectionsContext} from "../contexts/SectionsProvider";
import {
    calcDone,
    getModel,
    getRepeaterModels,
    instanceTitle,
    sectionNow
} from "../../common/section-questions/sections";
import {capitaliseFirst} from "../../common/section-questions/applicant/__strings";

import Steps from "../ui/outlet-views/Steps"
import Table from "../ui/outlet-views/Table"
import Menu from "../ui/outlet-views/Menu"

import HaveAny from "../ui/outlet-views/HaveAny"
import StepsCompleted from "../ui/outlet-views/StepsCompleted";

function Section(props) {
    const context = useContext(SectionsContext)
    const params = useParams()
    const location = useLocation();

    const [state, setState] = useState({
        isTransitioning: false,
        index: params?.index,
    })
    const [editing, setEditing] = useState(false)

    const sectionName = props.applicant ? params.section + '-' + props.applicant : params.section
    const section = context.sections.apply.find(i => i.name === sectionName)

    const toggleEdit = () => {
        setEditing(!editing)
    }
    const setIsTransitioning = () => {
        // console.log('turning on transitioning')
        setState({...state, isTransitioning: true})
    }
    const setIsNotTransitioning = () => {
        // console.log('turning off transitioning')
        setState({...state, isTransitioning: false})
    }
    const addInstance = async function () {
        return await context.addRepeater(section)
    }
    const removeInstance = (id) => {
        const copySection = {...section}
        copySection.index = id
        // console.log(copySection)
        context.removeRepeater(copySection)
    }
    const questionComponent = (section) => {
        let back = props?.steps ? '../..' : '../..'
        console.log(section.name)
        if (section.name==='setup'){
            back = '/'
        }
        if (!!props?.steps) {
            return <Steps
                section={section}
                back={back}
                transition={{on: setIsTransitioning, off: setIsNotTransitioning}}

            />
        }
        return <Table title={section.title} section={section} back={back}/>

    }
    const repeaterComponent = (section) => {
        if (params?.index) {
            if (section.progress < 100 && !props?.steps) {
                return <Navigate to="steps"/>
            }
            section.index = params.index
            let model = getModel(section, section.models[0], section.props.mortgage)
            section.title = instanceTitle(section, model)
            console.log(section)
            return questionComponent(section)
        }
        const rows = getRepeaterModels(section, section.models[0])
        const hasAny = rows.length
        const articled = function () {
            const first = section.defaultLabel.substr(0, 1).toLowerCase()
            return (['a', 'e', 'i', 'o', 'u'].includes(first)) ? 'an' : 'a'
        }
        const plural = function () {
            switch (section.defaultLabel) {
                case "Property":
                    return "Properties"
                default:
                    return section.defaultLabel + 's'
            }
        }
        const items = hasAny ? rows.map((instance, index) => {
            const copySection = {...section}
            copySection.index = instance.id
            copySection.title = instanceTitle(copySection, instance)
            copySection.link = instance.id
            copySection.progress = calcDone(copySection)
            return copySection
        }) : []
        if (!hasAny) {
            return <Navigate to={'any'}/>
        }
        // let anyAt0 = items.find(i=>calcDone(i)===0)
        // console.log(anyAt0)
        // if (anyAt0){
        //     return <Navigate to={anyAt0.index+'/steps'}/>
        // }
        return <Menu
            back="../../"
            items={items}
            progress={0}
            editing={editing}
            onEdit={toggleEdit}
            title={section.personalisedTitle}
            addInstance={addInstance}
            addText={'Add ' + (hasAny ? 'another' : articled()) + section.defaultLabel.toLowerCase()}
            removeInstance={removeInstance}
        />

    }
    const endComponent = (section) => {
        if (section?.dynamicLabel) {
            const yes = async () => {
                const path = await context.addRepeater(section)
                return '../../' + path + '/steps'
            }
            const no = async () => {
                return '../../../'
            }
            let description = 'more ' + section.title.toLowerCase() + ' to add'
            let question = section.applicant === 1 ? `Do you have any ${description}?` : `Does ${section.props.mortgage.applicant2?.firstName ? section.props.mortgage.applicant2.firstName : 'the other applicant'} have any ${description}?`
            return <StepsCompleted repeater={true} yesPath={yes} noPath={no} question={question}/>
        }
        return <StepsCompleted/>

    }

    const haveAnyComponent = (section) => {
        const yes = async () => {
            const appKey = `applicant${section.applicant}`
            const key = `has${capitaliseFirst(section.root)}`
            const mutator = {}
            mutator[key] = true
            context.save.financial(section.props.mortgage[appKey].financial, mutator)

            const path = await context.addRepeater(section)
            return '../' + path + '/steps'
        }
        const no = async () => {
            const appKey = `applicant${section.applicant}`
            const key = `has${capitaliseFirst(section.root)}`
            const mutator = {}
            mutator[key] = false
            context.save.financial(section.props.mortgage[appKey].financial, mutator)
            return '../../'
        }
        let description = section.title.toLowerCase()
        let question = section.applicant === 1 ? `Do you have any ${description}?` : `Does ${section.props.mortgage.applicant2?.firstName ? section.props.mortgage.applicant2.firstName : 'the other applicant'} have any ${description}?`
        return <HaveAny delayStart={1} yesPath={yes} noPath={no} question={question}/>
    }
    if (section) {
        section.progress = sectionNow(section)
        // if its a repeater
        if (props?.end) {
            return endComponent(section)
        }
        if (section?.dynamicLabel) {
            if (props?.any) {
                return haveAnyComponent(section)
            }
            return repeaterComponent(section)
        }
        if (section.progress < 100 && !props?.steps){
            return <Navigate to="steps"/>

        }
        return questionComponent(section)
    }
    return (
        <div>Oops</div>
    );
}

export default Section;